import { Component, ViewChild, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { first } from 'rxjs/operators';
import { Globals } from '../_helpers';
import { AlertService, AuthenticationService } from '../_services';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import swal, { SweetAlertOptions } from 'sweetalert2';
import { SwalComponent } from '@toverux/ngx-sweetalert2';

@Component({
  selector: 'app-dashboard',
  templateUrl: './results.component.html',
  styleUrls: ['./dashboard.component.css']
})


export class ResultsComponent implements OnInit {

  public alertOption: SweetAlertOptions = {};  
  @ViewChild('sectorSelSwal') private sectorSelSwal: SwalComponent;

  title = 'Pareekshn';
  selectedValue: any = 'topic';
  userinfo: any;
  studentid: number = 0;
  isErrorUsername: boolean;
  errorMsg: any;
  loading: boolean;
  examdata: any;
  isValid = true;
  usertoken: string;
  exam_id_result: number = 0;
  student_id: number = 0;
  returnUrl : string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private alertService: AlertService,
    private globals: Globals,
    private spinner: NgxSpinnerService,
    private http: HttpClient
  ) { }

  ngOnInit() {

    this.userinfo = JSON.parse(localStorage.getItem('userinfo_ps')); //console.log(this.userinfo);
    this.studentid = this.userinfo['student_id'];
    this.usertoken = this.userinfo['usertoken'];
    var step1 = this.route.snapshot.paramMap.get("step1");
    var step2 = this.route.snapshot.paramMap.get("step2");

    if(step1 == null || step1 == undefined)
    {
      this.returnUrl = '/dashboard';    
    }
    else{
      this.exam_id_result = parseInt(step1);   
    }
    if(step2 == null || step2 == undefined)
    {
      this.returnUrl = '/dashboard';   
    }
    else
    {
      this.student_id = parseInt(step2);   
    } 
    if(this.student_id > 0 && this.exam_id_result > 0)   
    {
      this.fetchResults(); 
    }
  }

pdfArrLength;
nosArrLength;
exam_info;
noslist = [];
pdflist = [];
examsdata = []; 
attemptDate;
timetaken;
resultstatus;
fetchResults()
{ 
  this.loading = true;
  this.spinner.show();
    this.authenticationService.getResults(this.globals.root_url, this.studentid, this.usertoken, this.student_id, this.exam_id_result)
      .pipe(first())
      .subscribe(
        data => {
          if (data.code == 1000) {
            this.exam_info = data.exam_info;            
            this.noslist = data.nos;
            this.nosArrLength = this.noslist.length; 
            this.pdfArrLength = data.pdf_links.length; 
            for(var m =0; m < this.pdfArrLength; ++m)
            {
              let ldt = data.pdf_links[m].add_date;
              let ldt_split = ldt.split("T");
              var d = new Date(ldt_split);
              this.attemptDate = this.formatDate(d); 
              this.timetaken = this.convertStoMs(data.pdf_links[m].total_time_taken);  
              if(data.pdf_links[m].pass_status == 2)
              {
                this.resultstatus = 'Fail';
              }
              else
              {
                this.resultstatus = 'Pass';
              }

              this.pdflist.push({ add_date: this.attemptDate, total_time_taken: this.timetaken, correct_question: data.pdf_links[m].correct_question, total_question: data.pdf_links[m].total_question, attempted_question: data.pdf_links[m].attempted_question, pdf_link: data.pdf_links[m].pdf_link, pass_status: this.resultstatus});           
            }             
            this.loading = false;
            this.spinner.hide();
          }
          else {
            this.errorMsg = data.status;
            this.loading = false;
            this.spinner.hide();
          }          
        },
        error => {
          this.errorMsg = 'No Result Found !!';
          this.alertService.error(error);
          this.loading = false;
          this.spinner.hide();
        }
      );
 }
 viewResult(pdf_link)
 {
  window.open(pdf_link, "_blank");
 }
  formatDate(date) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0'+minutes : minutes;
    var strTime = hours + ':' + minutes + ' ' + ampm;
    return (date.getMonth()+1) + "/" + date.getDate() + "/" + date.getFullYear() + "  " + strTime;
  }
  convertStoMs(seconds) {
     let minutes = ~~(seconds / 60);
     let extraSeconds = seconds % 60;
     return minutes + " Min " + extraSeconds + " Seconds";
  } 
 goDashboard()
 {
  this.router.navigateByUrl('/dashboard'); 
 }    
}





